import { FormatType } from "../../Alert/Filter/FilterType";
import { Industry } from "../../Industry";
import {
  ConfigurationActionIcon,
  ConfigurationFormType,
  ConfigurationPageTable,
  ConfigurationPageType,
  ConfigurationTableFilterType,
  RuleTypeType,
} from "../interfaces";

export const SETUP_EVENT_PAGE: ConfigurationPageTable = {
  type: ConfigurationPageType.TABLE,
  label: "EVENT_MENU",
  menuLabel: "EVENT_MENU",
  pageLabel: "EVENT_TITLE_SETUP",
  path: "events",
  hideInMenu: true,
  description: "CONF_DESC_SETUP_EVENTS",
  model: {
    entityName: "name",
    label: "EVENT_MENU",
    path: "/api/events",
    bulkPath: "/api/events/bulk-updates",
    name: "Evènements",
    attributes: [
      {
        key: "property.hebergement_nom_court",
        order: 1,
        label: "PROPERTY",
        visible: true,
      },
      {
        key: "short_name",
        order: 2,
        label: "SHORT_NAME",
        visible: true,
      },
      {
        key: "name",
        order: 3,
        label: "LONG_NAME",
        visible: true,
      },
      {
        key: "event_nandc.name",
        order: 4,
        label: "QUALIFICATION_N&C",
        visible: true,
      },
      {
        key: "impact",
        order: 5,
        label: "IMPACT",
        visible: true,
        rules: [
          {
            column: "impact",
            type: RuleTypeType.TRANSLATION,
          },
        ],
      },
      {
        align: "right",
        key: "start_date",
        order: 6,
        label: "DATE_START",
        type: FormatType.DATE,
        visible: true,
      },
      {
        align: "right",
        key: "end_date",
        order: 7,
        label: "DATE_END",
        type: FormatType.DATE,
        visible: true,
      },
      {
        align: "right",
        key: "day_before_start_included",
        order: 8,
        label: "DAY_BEFORE_INCLUDED",
        type: FormatType.BOOLEAN,
        visible: true,
        rules: [
          {
            type: "compare-with",
            value: false,
            operator: "eq",
            options: {
              color: "text.cell",
            },
          },
          {
            type: "compare-with",
            value: true,
            operator: "eq",
            options: {
              color: "text.accent",
            },
          },
        ],
      },
      {
        align: "right",
        key: "nb_days_end_without_impact",
        order: 9,
        label: "NB_DAY_WITHOUT_IMPACT",
        visible: true,
      },
      {
        align: "right",
        key: "is_main",
        order: 10,
        label: "EVENT_IS_MAIN",
        type: FormatType.BOOLEAN,
        visible: true,
        rules: [
          {
            type: "compare-with",
            value: false,
            operator: "eq",
            options: {
              color: "text.cell",
            },
          },
          {
            type: "compare-with",
            value: true,
            operator: "eq",
            options: {
              color: "text.accent",
            },
          },
        ],
      },
      {
        key: "detail",
        order: 11,
        label: "EVENT_DETAIL",
        visible: true,
        includedIndustries: [Industry.CRUISE],
      },
      {
        key: "type",
        order: 12,
        label: "EVENT_TYPE",
        visible: true,
        includedIndustries: [Industry.CRUISE],
      },
      {
        key: "sub_type",
        order: 13,
        label: "EVENT_SUB_TYPE",
        visible: true,
        includedIndustries: [Industry.CRUISE],
      },
      {
        key: "master_type",
        order: 14,
        label: "EVENT_MASTER_TYPE",
        visible: true,
        includedIndustries: [Industry.CRUISE],
      },
      {
        key: "cluster_pricing",
        order: 15,
        label: "EVENT_CLUSTER_PRICING",
        visible: true,
        includedIndustries: [Industry.CRUISE],
      },
      {
        key: "cluster_pricing_2",
        order: 16,
        label: "EVENT_CLUSTER_PRICING_2",
        visible: true,
        includedIndustries: [Industry.CRUISE],
      },
      {
        key: "premium_pricing",
        order: 17,
        label: "EVENT_PREMIUM_PRICING",
        visible: true,
        includedIndustries: [Industry.CRUISE],
      },
      {
        key: "charter",
        order: 18,
        label: "EVENT_CHARTER",
        visible: true,
        includedIndustries: [Industry.CRUISE],
      },
      {
        key: "charter_name",
        order: 19,
        label: "EVENT_CHARTER_NAME",
        visible: true,
        includedIndustries: [Industry.CRUISE],
      },
      {
        key: "cruise_type",
        order: 20,
        label: "EVENT_CRUISE_TYPE",
        visible: true,
        includedIndustries: [Industry.CRUISE],
      },
      {
        key: "theme",
        order: 21,
        label: "EVENT_THEME",
        visible: true,
        includedIndustries: [Industry.CRUISE],
      },
      {
        key: "guest",
        order: 22,
        label: "EVENT_GUEST",
        visible: true,
        includedIndustries: [Industry.CRUISE],
      },
      {
        key: "partnership",
        order: 23,
        label: "EVENT_PARTNERSHIP",
        visible: true,
        includedIndustries: [Industry.CRUISE],
      },
      {
        key: "analyst",
        order: 24,
        label: "ANALYST",
        visible: true,
        includedIndustries: [Industry.CRUISE],
      },
      {
        key: "capacity",
        order: 25,
        label: "CAPACITY",
        visible: true,
        includedIndustries: [Industry.CRUISE],
      },
      {
        key: "capacity_pax",
        order: 26,
        label: "CAPACITY_PAX",
        visible: true,
        includedIndustries: [Industry.CRUISE],
      },
      {
        key: "los",
        order: 27,
        label: "EVENT_LOS",
        visible: true,
        includedIndustries: [Industry.CRUISE],
      },
      {
        key: "period_pricing",
        order: 28,
        label: "EVENT_PERIOD_PRICING",
        visible: true,
        includedIndustries: [Industry.CRUISE],
      },
      {
        key: "conditions_tarifaires",
        order: 29,
        label: "EVENT_CONDITIONS_TARIFAIRES",
        visible: true,
        includedIndustries: [Industry.CRUISE],
      },
    ],
    filters: [
      {
        type: ConfigurationTableFilterType.Select,
        api: "/api/properties/",
        apiParams: {
          page_size: 100,
          ordering: "hebergement_nom_court",
        },
        key: "property",
        labelKey: "hebergement_nom_court",
        label: "PROPERTY",
        lookup: "property",
      },
      {
        type: ConfigurationTableFilterType.DatePicker,
        lookup: "start_date__gte",
        label: "START_DATE",
        maxDateField: "end_date__lte",
      },
      {
        type: ConfigurationTableFilterType.DatePicker,
        lookup: "end_date__lte",
        label: "END_DATE",
        minDateField: "start_date__gte",
      },
      {
        type: ConfigurationTableFilterType.Search,
      },
      {
        type: ConfigurationTableFilterType.ResetButton,
      },
    ],
    export: { path: "/api/events/export" },
    import: { path: "/api/events/presign-url" },
    actions: [
      {
        type: "route",
        to: "/configuration/event-suggestions/",
        label: "EVENT_SUGGESTIONS_BUTTON",
        icon: ConfigurationActionIcon.SUGGESTIONS,
        // The batch only produces suggestions while this is on, so the page
        // behind the button would be permanently empty otherwise.
        flagRequired: "event_suggestions_enabled",
        // It opens another page rather than acting on these rows, so it should not
        // look like Create / Export / Import.
        emphasis: "accent",
      },
    ],
  },
  options: {
    formFields: [
      {
        type: ConfigurationFormType.Select,
        api: "/api/properties/",
        apiParams: {
          page_size: 100,
          ordering: "hebergement_nom_court",
        },
        key: "property",
        label: "PROPERTY",
        labelKey: "hebergement_nom_court",
        watchLookup: "property",
      },
      {
        key: "name",
        label: "EVENT_NAME",
        type: ConfigurationFormType.Input,
      },
      {
        key: "impact",
        label: "IMPACT",
        type: ConfigurationFormType.StaticSelect,
      },
      {
        type: ConfigurationFormType.Select,
        api: "/api/events-nandc/",
        apiParams: {
          page_size: 100,
          ordering: "name",
        },
        key: "event_nandc",
        label: "QUALIFICATION_N&C",
        labelKey: "name",
      },
      {
        key: "date_range",
        startDateField: "start_date",
        endDateField: "end_date",
        startDateLabel: "DATE_START",
        endDateLabel: "DATE_END",
        type: ConfigurationFormType.DateRangePicker,
      },
      {
        key: "day_before_start_included",
        label: "DAY_BEFORE_INCLUDED",
        type: ConfigurationFormType.Check,
      },
      {
        key: "nb_days_end_without_impact",
        label: "NB_DAY_WITHOUT_IMPACT",
        type: ConfigurationFormType.Input,
        inputType: "integer",
        inputProps: {
          type: "number",
          inputProps: {
            min: 0,
            step: "any",
          },
        },
      },
      {
        key: "detail",
        label: "EVENT_DETAIL",
        type: ConfigurationFormType.Input,
        includedIndustries: [Industry.CRUISE],
      },
      {
        key: "type",
        label: "EVENT_TYPE",
        type: ConfigurationFormType.Input,
        includedIndustries: [Industry.CRUISE],
      },
      {
        key: "sub_type",
        label: "EVENT_SUB_TYPE",
        type: ConfigurationFormType.Input,
        includedIndustries: [Industry.CRUISE],
      },
      {
        key: "master_type",
        label: "EVENT_MASTER_TYPE",
        type: ConfigurationFormType.Input,
        includedIndustries: [Industry.CRUISE],
      },
      {
        key: "cluster_pricing",
        label: "EVENT_CLUSTER_PRICING",
        type: ConfigurationFormType.Input,
        includedIndustries: [Industry.CRUISE],
      },
      {
        key: "cluster_pricing_2",
        label: "EVENT_CLUSTER_PRICING_2",
        type: ConfigurationFormType.Input,
        includedIndustries: [Industry.CRUISE],
      },
      {
        key: "premium_pricing",
        label: "EVENT_PREMIUM_PRICING",
        type: ConfigurationFormType.Input,
        includedIndustries: [Industry.CRUISE],
      },
      {
        key: "charter",
        label: "EVENT_CHARTER",
        type: ConfigurationFormType.Input,
        includedIndustries: [Industry.CRUISE],
      },
      {
        key: "charter_name",
        label: "EVENT_CHARTER_NAME",
        type: ConfigurationFormType.Input,
        includedIndustries: [Industry.CRUISE],
      },
      {
        key: "cruise_type",
        label: "EVENT_CRUISE_TYPE",
        type: ConfigurationFormType.Input,
        includedIndustries: [Industry.CRUISE],
      },
      {
        key: "theme",
        label: "EVENT_THEME",
        type: ConfigurationFormType.Input,
        includedIndustries: [Industry.CRUISE],
      },
      {
        key: "guest",
        label: "EVENT_GUEST",
        type: ConfigurationFormType.Input,
        includedIndustries: [Industry.CRUISE],
      },
      {
        key: "partnership",
        label: "EVENT_PARTNERSHIP",
        type: ConfigurationFormType.Input,
        includedIndustries: [Industry.CRUISE],
      },
      {
        key: "analyst",
        label: "ANALYST",
        type: ConfigurationFormType.Input,
        includedIndustries: [Industry.CRUISE],
      },
      {
        inputType: "integer",
        key: "capacity",
        label: "CAPACITY",
        type: ConfigurationFormType.Input,
        includedIndustries: [Industry.CRUISE],
      },
      {
        inputType: "integer",
        key: "capacity_pax",
        label: "CAPACITY_PAX",
        type: ConfigurationFormType.Input,
        includedIndustries: [Industry.CRUISE],
      },
      {
        key: "is_main",
        label: "EVENT_IS_MAIN",
        type: ConfigurationFormType.Check,
      },
      {
        inputType: "integer",
        key: "los",
        label: "EVENT_LOS",
        type: ConfigurationFormType.Input,
        includedIndustries: [Industry.CRUISE],
      },
      {
        key: "period_pricing",
        label: "EVENT_PERIOD_PRICING",
        type: ConfigurationFormType.Input,
        includedIndustries: [Industry.CRUISE],
      },
      {
        key: "conditions_tarifaires",
        label: "EVENT_CONDITIONS_TARIFAIRES",
        type: ConfigurationFormType.Input,
        includedIndustries: [Industry.CRUISE],
      },
    ],
    creatable: true,
    createOptions: [
      {
        key: "property",
        flex: "100%",
        required: true,
      },
      {
        key: "name",
        flex: "50%",
        required: true,
      },
      {
        key: "event_nandc",
        flex: "50%",
        required: true,
      },
      {
        key: "date_range",
        flex: "100%",
        required: true,
      },
      {
        key: "day_before_start_included",
        flex: "50%",
      },
      {
        key: "nb_days_end_without_impact",
        flex: "50%",
      },
      {
        key: "detail",
        flex: "50%",
      },
      {
        key: "type",
        flex: "50%",
      },
      {
        key: "sub_type",
        flex: "50%",
      },
      {
        key: "master_type",
        flex: "50%",
      },
      {
        key: "cluster_pricing",
        flex: "50%",
      },
      {
        key: "cluster_pricing_2",
        flex: "50%",
      },
      {
        key: "premium_pricing",
        flex: "50%",
      },
      {
        key: "charter",
        flex: "50%",
      },
      {
        key: "charter_name",
        flex: "50%",
      },
      {
        key: "cruise_type",
        flex: "50%",
      },
      {
        key: "theme",
        flex: "50%",
      },
      {
        key: "guest",
        flex: "50%",
      },
      {
        key: "partnership",
        flex: "50%",
      },
      {
        key: "analyst",
        flex: "50%",
      },
      {
        key: "capacity",
        flex: "50%",
      },
      {
        key: "capacity_pax",
        flex: "50%",
      },
      {
        key: "is_main",
        flex: "50%",
      },
      {
        key: "impact",
        flex: "50%",
      },
      {
        key: "los",
        flex: "50%",
      },
      {
        key: "period_pricing",
        flex: "50%",
      },
      {
        key: "conditions_tarifaires",
        flex: "50%",
      },
    ],
    copyable: false,
    editable: true,
    editOptions: [
      {
        key: "property",
        flex: "100%",
        required: true,
      },
      {
        key: "name",
        flex: "50%",
        required: true,
      },
      {
        key: "event_nandc",
        flex: "50%",
        required: true,
      },
      {
        key: "date_range",
        flex: "100%",
        required: true,
      },
      {
        key: "day_before_start_included",
        flex: "50%",
      },
      {
        key: "nb_days_end_without_impact",
        flex: "50%",
      },
      {
        key: "detail",
        flex: "50%",
      },
      {
        key: "type",
        flex: "50%",
      },
      {
        key: "sub_type",
        flex: "50%",
      },
      {
        key: "master_type",
        flex: "50%",
      },
      {
        key: "cluster_pricing",
        flex: "50%",
      },
      {
        key: "cluster_pricing_2",
        flex: "50%",
      },
      {
        key: "premium_pricing",
        flex: "50%",
      },
      {
        key: "charter",
        flex: "50%",
      },
      {
        key: "charter_name",
        flex: "50%",
      },
      {
        key: "cruise_type",
        flex: "50%",
      },
      {
        key: "theme",
        flex: "50%",
      },
      {
        key: "guest",
        flex: "50%",
      },
      {
        key: "partnership",
        flex: "50%",
      },
      {
        key: "analyst",
        flex: "50%",
      },
      {
        key: "capacity",
        flex: "50%",
      },
      {
        key: "capacity_pax",
        flex: "50%",
      },
      {
        key: "is_main",
        flex: "50%",
      },
      {
        key: "impact",
        flex: "50%",
      },
      {
        key: "los",
        flex: "50%",
      },
      {
        key: "period_pricing",
        flex: "50%",
      },
      {
        key: "conditions_tarifaires",
        flex: "50%",
      },
    ],
    deletable: true,
    editSelectedOptions: [
      {
        key: "event_nandc",
        flex: "100%",
      },
      {
        key: "day_before_start_included",
        flex: "100%",
      },
      {
        key: "is_main",
        flex: "100%",
      },
    ],
  },
};
